import { render, staticRenderFns } from "./Bandwidth_Session.vue?vue&type=template&id=628533a6&"
import script from "./Bandwidth_Session.vue?vue&type=script&lang=js&"
export * from "./Bandwidth_Session.vue?vue&type=script&lang=js&"
import style0 from "./Bandwidth_Session.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports